import React, { useState, useEffect } from 'react';

const Header2HE = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  {/*const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [theme]);*/}

  return (
    <><body class="hebrew-rtl">
      <div
        id="enby-header"
        style={{
          background:
            "linear-gradient(315deg, rgb(0,0,0) 0%, rgb(7, 7, 14) 20%, rgb(14, 14, 28) 40%, rgb(21, 21, 42) 60%, rgb(28, 28, 56) 80%, rgb(35, 35, 70) 100%)",
          display: "block",
          position: "relative",
          zIndex: 50,
          boxSizing: "border-box",
          minHeight: "80px",
        }}
      >
        <div
          id="pl-enby-header"
          className="dwc-pl--enbyHeader__HeaderMain"
          style={{
            border: "none",
            boxSizing: "border-box",
            minHeight: "80px",
            height: "80px",
            position: "relative",
            padding: "0px 10px",
            margin: "0px auto",
            width: "100%",
            display: "none",
          }}
        >
          <div
            className="dwc-pl--enbyHeader__HeaderNavBar"
            style={{
              boxSizing: "inherit",
              margin: "0px auto",
              padding: "0px",
              border: "none",
              display: "table",
              height: "100%",
              width: "100%",
              maxWidth: "1080px",
              color: "rgb(255, 255, 255)",
            }}
          >
            <div
              className="dwc-pl--enbyHeader__HeaderLogo"
              style={{
                boxSizing: "inherit",
                border: "none",
                display: "table-cell",
                verticalAlign: "middle",
                width: "150px",
                paddingRight: "26px",
              }}
            >
              <a
                href="/"
                style={{
                  boxSizing: "inherit",
                  transition: "color 0.4s ease 0s",
                  color: "rgb(0,0,0)",
                  textDecoration: "none",
                }}
              >
               <img
                            className="rights-logo h-20 w-auto inline-block"
                            alt="EnbyBase"
                            src="../enbybasefooterlogo.png"
                            style={{
                              borderWidth: "0px",
                              borderStyle: "solid",
                              borderColor: "rgb(0,0,0)",
                              boxSizing: "border-box",
                              verticalAlign: "middle",
                              display: "inline-block",
                              height: "auto",
                              maxWidth: "150px",
                            }}
                          />
              </a>
            </div>
            <div
              className="dwc-pl--enbyHeader__HeaderNavBarBg"
              style={{ boxSizing: "inherit" }}
            />
            <div
              className="dwc-pl--enbyHeader__HeaderNavMenu"
              style={{
                border: "none",
                padding: "0px",
                margin: "0px",
                display: "table-cell",
                position: "relative",
                boxSizing: "border-box",
                verticalAlign: "middle",
                zIndex: 8,
              }}
            >
              <div
                className="dwc-pl--enbyHeader__NavMenuWrapper"
                style={{ boxSizing: "inherit" }}
              >
                <div
                  className="dwc-pl--enbyHeader__HeaderMainLinks"
                  style={{
                    display: "table",
                    boxSizing: "border-box",
                    height: "100%",
                    verticalAlign: "top",
                    width: "calc(100% - 150px)",
                  }}
                >
                  <div
                    className="dwc-pl--enbyHeader__NavSpace"
                    style={{
                      boxSizing: "inherit",
                      display: "table-cell",
                      verticalAlign: "bottom",
                      height: "calc(46.2px)",
                    }}
                  />
                  <button
                    className="dwc-pl--enbyHeader__NavBtn dwc-pl--enbyHeader__SingleLineLink"
                    
                    target="_self"
                    style={{
                      transition: "color 0.4s ease 0s",
                      textDecoration: "none",
                      display: "inline-block",
                      color: "rgb(255, 255, 255)",
                      boxSizing: "border-box",
                      textAlign: "center",
                      fontSize: "13px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginRight: "18px",
                      lineHeight: 1.2,
                      paddingTop: "25px",
                    }}
                  >
                    Articles
                  </button>
                  <button
                    className="dwc-pl--enbyHeader__NavBtn dwc-pl--enbyHeader__SingleLineLink"
                    
                    target="_self"
                    style={{
                      transition: "color 0.4s ease 0s",
                      textDecoration: "none",
                      display: "inline-block",
                      color: "rgb(255, 255, 255)",
                      boxSizing: "border-box",
                      textAlign: "center",
                      fontSize: "13px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginRight: "18px",
                      lineHeight: 1.2,
                      paddingTop: "25px",
                    }}
                  >
                    Forums
                  </button>
                  <button
                    className="dwc-pl--enbyHeader__NavBtn dwc-pl--enbyHeader__SingleLineLink"
                    
                    target="_self"
                    style={{
                      transition: "color 0.4s ease 0s",
                      textDecoration: "none",
                      display: "inline-block",
                      color: "rgb(255, 255, 255)",
                      boxSizing: "border-box",
                      textAlign: "center",
                      fontSize: "13px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginRight: "18px",
                      lineHeight: 1.2,
                      paddingTop: "25px",
                    }}
                  >
                    Discord Server
                  </button>
                  <button
                    className="dwc-pl--enbyHeader__NavBtn dwc-pl--enbyHeader__SingleLineLink"
                    href=""
                    target="_self"
                    style={{
                      transition: "color 0.4s ease 0s",
                      textDecoration: "none",
                      display: "inline-block",
                      color: "rgb(255, 255, 255)",
                      boxSizing: "border-box",
                      textAlign: "center",
                      fontSize: "13px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginRight: "18px",
                      lineHeight: 1.2,
                      paddingTop: "25px",
                    }}
                  >
                    Miles
                  </button>
                  <a
                    className="dwc-pl--enbyHeader__NavBtn dwc-pl--enbyHeader__SingleLineLink"
                    href="/about"
                    target="_self"
                    style={{
                      transition: "color 0.4s ease 0s",
                      textDecoration: "none",
                      display: "inline-block",
                      color: "rgb(255, 255, 255)",
                      boxSizing: "border-box",
                      textAlign: "center",
                      fontSize: "13px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginRight: "18px",
                      lineHeight: 1.2,
                      paddingTop: "25px",
                    }}
                  >
                    About us
                  </a>
                </div>
                <div
                  className="dwc-pl--enbyHeader__HeaderNavLocale"
                  style={{
                    border: "none",
                    position: "absolute",
                    display: "block",
                    color: "rgb(255, 255, 255)",
                    boxSizing: "border-box",
                    top: "0px",
                    right: "0px",
                    bottom: "50px",
                  }}
                >
                  <span
                    style={{
                      boxSizing: "inherit",
                      fontFamily:
                        'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                    }}
                  >
                    <div
                      className="hydrated"
                      style={{ boxSizing: "inherit", visibility: "inherit" }}
                    >
                      <div style={{ boxSizing: "inherit" }}>
                        <div
                          className="dwc-pl--LocaleSelector__Root"
                          style={{
                            transition: "all 0.4s ease 0s",
                            textDecoration: "none",
                            fontFamily:
                              'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                            fontSize: "11px",
                            textTransform: "uppercase",
                            letterSpacing: "1.5px",
                            fontWeight: 500,
                            color: "rgb(255, 255, 255)",
                            textAlign: "right",
                            boxSizing: "border-box",
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            marginTop: "5px",
                          }}
                        >
                          <span
                            className="dwc-pl--LocaleSelector__HideNonDesktop"
                            style={{
                              boxSizing: "inherit",
                              fontFamily:
                                'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                            }}
                          >
                            <span
                              className="dwc-pl--enbyHeader__HeaderFeedback"
                              style={{
                                boxSizing: "inherit",
                                fontFamily:
                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <a
                                className="dwc-pl--enbyHeader__FeedbackHelp dwc--newsAlert__container"
                                style={{
                                  boxSizing: "inherit",
                                  transition: "color 0.4s ease 0s",
                                  textDecoration: "none",
                                  paddingRight: "17px",
                                  color: "rgb(255, 255, 255)",
                                  display: "inline-block",
                                  position: "relative",
                                }}
                              >
                                <span
                                  className="dwc--newsAlert__bell__white"
                                  style={{
                                    boxSizing: "inherit",
                                    fontFamily:
                                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                    background:
                                      'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI5MDRfMTEwMTIpIj4KPHBhdGggZD0iTTcuNzEwNzMgMTAuMjkyQzguMTc5MjcgMTAuMjkyIDguNDI2ODEgMTAuODQ2NyA4LjExNDI3IDExLjE5NTVDNy45MTEyNCAxMS40MjI3IDcuNjYyNDggMTEuNjA0NCA3LjM4NDMgMTEuNzI4OEM3LjEwNjEyIDExLjg1MzEgNi44MDQ4MSAxMS45MTcyIDYuNTAwMSAxMS45MTdDNi4xOTU0IDExLjkxNzIgNS44OTQwOSAxMS44NTMxIDUuNjE1OTEgMTEuNzI4OEM1LjMzNzczIDExLjYwNDQgNS4wODg5NyAxMS40MjI3IDQuODg1OTQgMTEuMTk1NUM0LjU4Njk0IDEwLjg2MTggNC44MDAzNSAxMC4zNDAyIDUuMjI5MzUgMTAuMjk1OEw1LjI4ODk0IDEwLjI5MjVMNy43MTA3MyAxMC4yOTJaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNi41MDAwNSAxLjA4MzAxQzcuMjM1NjQgMS4wODMwMSA3Ljg1NzQ3IDEuNTcyMTMgOC4wNTczNSAyLjI0MjcyTDguMDgyMjYgMi4zMzUzNEw4LjA4NjU5IDIuMzU4NjNDOC42ODM3MiAyLjY5NTUgOS4xOTI1NiAzLjE2OTAyIDkuNTcxNDIgMy43NDA0MkM5Ljk1MDI4IDQuMzExODMgMTAuMTg4NCA0Ljk2NDg1IDEwLjI2NjMgNS42NDYwMUwxMC4yODE0IDUuODAxNDdMMTAuMjkxNyA1Ljk1ODAxVjcuNTQ1NjNMMTAuMzAzMSA3LjYxOTNDMTAuMzc3MyA4LjAxODQxIDEwLjU5ODEgOC4zNzUzMSAxMC45MjIyIDguNjE5NzZMMTEuMDEyNyA4LjY4MzEzTDExLjEwMDQgOC43MzY3NkMxMS41NjYzIDkuMDAwNTUgMTEuNDAzOCA5LjY5MzM0IDEwLjg5NjIgOS43NDY0MkwxMC44MzM0IDkuNzQ5NjdIMi4xNjY3MkMxLjYwOTg5IDkuNzQ5NjcgMS40MTU0MyA5LjAxMDg0IDEuODk5NjggOC43MzY3NkMyLjEwNjA3IDguNjE5OTYgMi4yODQzOSA4LjQ1OTQgMi40MjIxNCA4LjI2NjM2QzIuNTU5ODggOC4wNzMzMSAyLjY1MzcgNy44NTI0NiAyLjY5NzAxIDcuNjE5M0wyLjcwODM5IDcuNTQxODRMMi43MDg5MyA1LjkzMzA5QzIuNzQxOTUgNS4yMjU2MSAyLjk0Nzg5IDQuNTM3MDEgMy4zMDg3MSAzLjkyNzU1QzMuNjY5NTMgMy4zMTgxIDQuMTc0MjMgMi44MDYzOCA0Ljc3ODY0IDIuNDM3MTdMNC45MTI5NyAyLjM1ODA5TDQuOTE4MzkgMi4zMzQ4QzQuOTk1MDEgMi4wMTA5IDUuMTY5MTUgMS43MTgyOSA1LjQxNzMxIDEuNDk2NDhDNS42NjU0NyAxLjI3NDY3IDUuOTc1NyAxLjEzNDMyIDYuMzA2MTQgMS4wOTQzOEw2LjQwNDcyIDEuMDg1MTdMNi41MDAwNSAxLjA4MzAxWiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yOTA0XzExMDEyIj4KPHJlY3Qgd2lkdGg9IjEzIiBoZWlnaHQ9IjEzIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=") center center no-repeat transparent',
                                    width: "15px",
                                    height: "15px",
                                    display: "inline-block",
                                    position: "relative",
                                    top: "3px",
                                  }}
                                />
                              </a>
                              <span
                                className="dwc-pl--enbyHeader__OrangeSeparator"
                                style={{
                                  boxSizing: "inherit",
                                  fontFamily:
                                    'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                  borderLeft: "1px solid rgb(255, 159, 0)",
                                  paddingRight: "10px",
                                  display: "inline-block",
                                  height: "8px",
                                }}
                              />
                              <span title="Theme (light/dark)"
                              style={{
                                boxSizing: "inherit",
                                transition: "color 0.4s ease 0s",
                                textDecoration: "none",
                                paddingRight: "17px",
                                color: "rgb(255, 255, 255)"}}>
                                THEME
                              </span>
                              <span
                                className="dwc-pl--enbyHeader__OrangeSeparator"
                                style={{
                                  boxSizing: "inherit",
                                  fontFamily:
                                    'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                  borderLeft: "1px solid rgb(255, 159, 0)",
                                  paddingRight: "10px",
                                  display: "inline-block",
                                  height: "8px",
                                }}
                              />
                              <a
                                className="dwc-pl--enbyHeader__FeedbackHelp"
                                href="/feedback"
                                style={{
                                  boxSizing: "inherit",
                                  transition: "color 0.4s ease 0s",
                                  textDecoration: "none",
                                  paddingRight: "17px",
                                  color: "rgb(255, 255, 255)",
                                }}
                              >
                                FEEDBACK
                              </a>
                            </span>
                          </span>
                          <span
                            className="dwc-pl--LocaleSelector__LangSelector"
                            style={{
                              boxSizing: "inherit",
                              fontFamily:
                                'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="dwc-pl--LocaleSelector__GlobeIcon"
                              style={{
                                boxSizing: "inherit",
                                background:
                                  'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3Qm94PSIwIDAgMTAgMTAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYyICg5MTM5MCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+Z2xvYmUgaWNvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxwb2x5Z29uIGlkPSJwYXRoLTEiIHBvaW50cz0iMCAwIDkuOTk5OTQ0NDQgMCA5Ljk5OTk0NDQ0IDkuOTk5OTg4ODkgMCA5Ljk5OTk4ODg5Ij48L3BvbHlnb24+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9InRvcC1uYXYtbm90LWxvZ2dlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwMjAuMDAwMDAwLCAtMTQuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJnbG9iZS1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDIwLjAwMDAwMCwgMTQuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgIDxnIGlkPSJDbGlwLTIiPjwvZz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LjUxNjA1NTU2LDQuNzI1MSBDNy40ODQ3MjIyMiwzLjk3MTY1NTU2IDcuMzI2MDU1NTYsMy4yNDIzMjIyMiA3LjA1NDk0NDQ0LDIuNTcwMjExMTEgQzcuNTIxMTY2NjcsMi40MTY5ODg4OSA3Ljk2NTk0NDQ0LDIuMjEwNzY2NjcgOC4zODEzODg4OSwxLjk1NDMyMjIyIEM5LjA1MTgzMzMzLDIuNjk3OTg4ODkgOS40ODA3MjIyMiwzLjY2Mjk4ODg5IDkuNTQ0Mjc3NzgsNC43MjUxIEw3LjUxNjA1NTU2LDQuNzI1MSBaIE03LjA5MDM4ODg5LDcuMzM4MSBDNy4zNTE1LDYuNjYwMzIyMjIgNy40OTk2MTExMSw1LjkyNzU0NDQ0IDcuNTE5MDU1NTYsNS4xNzE4Nzc3OCBMOS41NDg5NDQ0NCw1LjE3MTg3Nzc4IEM5LjUwODk0NDQ0LDYuMjQzMSA5LjA5NzA1NTU2LDcuMjIwNDMzMzMgOC40MzkwNTU1Niw3Ljk3OTEgQzguMDE3NSw3LjcxMjQzMzMzIDcuNTY1Mjc3NzgsNy40OTczMjIyMiA3LjA5MDM4ODg5LDcuMzM4MSBMNy4wOTAzODg4OSw3LjMzODEgWiBNNi45MTUyNzc3OCw3Ljc1MDk4ODg5IEM3LjMzOTYxMTExLDcuODkwNTQ0NDQgNy43NDQ5NDQ0NCw4LjA3Njg3Nzc4IDguMTIzODMzMzMsOC4zMDgyMTExMSBDNy40NjEzODg4OSw4LjkzMzk4ODg5IDYuNjEyMTY2NjcsOS4zNjQyMTExMSA1LjY2OTI3Nzc4LDkuNTAzNjU1NTYgQzYuMTg1Mjc3NzgsOS4wMDY0MzMzMyA2LjYwNTM4ODg5LDguNDEwMzIyMjIgNi45MTUyNzc3OCw3Ljc1MDk4ODg5IEw2LjkxNTI3Nzc4LDcuNzUwOTg4ODkgWiBNMy4wNjYwNTU1Niw3Ljc0NjMyMjIyIEMzLjM3NTYxMTExLDguNDA2NDMzMzMgMy43OTU4MzMzMyw5LjAwMzQzMzMzIDQuMzEyMTY2NjcsOS41MDEzMjIyMiBDMy4zNzAxNjY2Nyw5LjM1Nzk4ODg5IDIuNTIzMTY2NjcsOC45MjQyMTExMSAxLjg2MzE2NjY3LDguMjk1NjU1NTYgQzIuMjQwNjExMTEsOC4wNjc1NDQ0NCAyLjY0MzgzMzMzLDcuODgzODc3NzggMy4wNjYwNTU1Niw3Ljc0NjMyMjIyIEwzLjA2NjA1NTU2LDcuNzQ2MzIyMjIgWiBNMi40NjM4MzMzMyw1LjE3MTg3Nzc4IEMyLjQ4MzUsNS45MjU3NjY2NyAyLjYzMTA1NTU2LDYuNjU2ODc3NzggMi44OTEwNTU1Niw3LjMzMzIxMTExIEMyLjQxODcyMjIyLDcuNDkwMjExMTEgMS45Njg5NDQ0NCw3LjcwMjMyMjIyIDEuNTQ4OTQ0NDQsNy45NjU0MzMzMyBDMC44OTc5NDQ0NDQsNy4yMDg2NTU1NiAwLjQ5MDgzMzMzMyw2LjIzNjY1NTU2IDAuNDUxMTY2NjY3LDUuMTcxODc3NzggTDIuNDYzODMzMzMsNS4xNzE4Nzc3OCBaIE0yLjkyNjA1NTU2LDIuNTc0OTg4ODkgQzIuNjU2MDU1NTYsMy4yNDU4Nzc3OCAyLjQ5ODA1NTU2LDMuOTczNDMzMzMgMi40NjY5NDQ0NCw0LjcyNTIxMTExIEwwLjQ1NTgzMzMzMyw0LjcyNTIxMTExIEMwLjUxODk0NDQ0NCwzLjY2OTU0NDQ0IDAuOTQzMTY2NjY3LDIuNzA5ODc3NzggMS42MDY4MzMzMywxLjk2Nzk4ODg5IEMyLjAyMDUsMi4yMjA2NTU1NiAyLjQ2MjgzMzMzLDIuNDIzODc3NzggMi45MjYwNTU1NiwyLjU3NDk4ODg5IEwyLjkyNjA1NTU2LDIuNTc0OTg4ODkgWiBNMy4xMDgzODg4OSwyLjE2Mzg3Nzc4IEMyLjY5NTgzMzMzLDIuMDMyODc3NzggMi4zMDA4MzMzMywxLjg1Nzc2NjY3IDEuOTMwMTY2NjcsMS42NDA1NDQ0NCBDMi41ODAzODg4OSwxLjA0NTg3Nzc4IDMuNDAyODMzMzMsMC42MzY4Nzc3NzggNC4zMTMzODg4OSwwLjQ5ODU0NDQ0NCBDMy44MTk5NDQ0NCwwLjk3MzY1NTU1NiAzLjQxMzk0NDQ0LDEuNTM4OTg4ODkgMy4xMDgzODg4OSwyLjE2Mzg3Nzc4IEwzLjEwODM4ODg5LDIuMTYzODc3NzggWiBNNS42NjY1LDAuNDk1OTg4ODg5IEM2LjU3ODcyMjIyLDAuNjMwNDMzMzMzIDcuNDAzOTQ0NDQsMS4wMzU4Nzc3OCA4LjA1Njk0NDQ0LDEuNjI4NDMzMzMgQzcuNjg0NSwxLjg0ODg3Nzc4IDcuMjg3Mjc3NzgsMi4wMjY1NDQ0NCA2Ljg3MjA1NTU2LDIuMTU5NTQ0NDQgQzYuNTY2MDU1NTYsMS41MzUyMTExMSA2LjE2MDA1NTU2LDAuOTcwNDMzMzMzIDUuNjY2NSwwLjQ5NTk4ODg4OSBMNS42NjY1LDAuNDk1OTg4ODg5IFogTTUuMjA2Mzg4ODksMi40NDcxIEw1LjIwNjM4ODg5LDAuNjgyMSBDNS43MDkxNjY2NywxLjEyODY1NTU2IDYuMTIzMjc3NzgsMS42NzI2NTU1NiA2LjQzMjcyMjIyLDIuMjgxODc3NzggQzYuMDM1ODMzMzMsMi4zNzYzMjIyMiA1LjYyNTI3Nzc4LDIuNDMyNTQ0NDQgNS4yMDYzODg4OSwyLjQ0NzEgTDUuMjA2Mzg4ODksMi40NDcxIFogTTUuMjA2Mzg4ODksNC43MjUxIEw1LjIwNjM4ODg5LDIuODkzNzY2NjcgQzUuNjkxNzIyMjIsMi44NzgxIDYuMTY3MDU1NTYsMi44MTEzMjIyMiA2LjYyNTE2NjY3LDIuNjk1NDMzMzMgQzYuODg1Mzg4ODksMy4zMjY0MzMzMyA3LjAzNzYxMTExLDQuMDEzOTg4ODkgNy4wNjkzODg4OSw0LjcyNTEgTDUuMjA2Mzg4ODksNC43MjUxIFogTTUuMjA2Mzg4ODksNy4wMDMyMTExMSBMNS4yMDYzODg4OSw1LjE3MTg3Nzc4IEw3LjA3MjM4ODg5LDUuMTcxODc3NzggQzcuMDUyNSw1Ljg4NDU0NDQ0IDYuOTEwODMzMzMsNi41NzQ3NjY2NyA2LjY2MTI3Nzc4LDcuMjExMjExMTEgQzYuMTkxOTQ0NDQsNy4wODk1NDQ0NCA1LjcwNDUsNy4wMTkzMjIyMiA1LjIwNjM4ODg5LDcuMDAzMjExMTEgTDUuMjA2Mzg4ODksNy4wMDMyMTExMSBaIE01LjIwNjM4ODg5LDcuNDQ5OTg4ODkgQzUuNjQyMjc3NzgsNy40NjUxIDYuMDY4OTQ0NDQsNy41MjQ4Nzc3OCA2LjQ4MDgzMzMzLDcuNjI2NDMzMzMgQzYuMTY2NSw4LjI3Mzc2NjY3IDUuNzM0OTQ0NDQsOC44NTA1NDQ0NCA1LjIwNjM4ODg5LDkuMzIwNTQ0NDQgTDUuMjA2Mzg4ODksNy40NDk5ODg4OSBaIE00Ljc1OTYxMTExLDcuNDQ5OTg4ODkgTDQuNzU5NjExMTEsOS4zMDQ0MzMzMyBDNC4yMzgxNjY2Nyw4LjgzNjU0NDQ0IDMuODExNzIyMjIsOC4yNjQ0MzMzMyAzLjUwMDcyMjIyLDcuNjIyOTg4ODkgQzMuOTA3ODMzMzMsNy41MjM1NDQ0NCA0LjMyOTI3Nzc4LDcuNDY0ODc3NzggNC43NTk2MTExMSw3LjQ0OTk4ODg5IEw0Ljc1OTYxMTExLDcuNDQ5OTg4ODkgWiBNNC43NTk2MTExMSw1LjE3MTg3Nzc4IEw0Ljc1OTYxMTExLDcuMDAzMjExMTEgQzQuMjY3MTY2NjcsNy4wMTkyMTExMSAzLjc4NTA1NTU2LDcuMDg3OTg4ODkgMy4zMjA1LDcuMjA3MjExMTEgQzMuMDcxNzIyMjIsNi41NzIxIDIuOTMwMzg4ODksNS44ODMxIDIuOTEwNjExMTEsNS4xNzE4Nzc3OCBMNC43NTk2MTExMSw1LjE3MTg3Nzc4IFogTTQuNzU5NjExMTEsMi44OTM3NjY2NyBMNC43NTk2MTExMSw0LjcyNTEgTDIuOTEzNjExMTEsNC43MjUxIEMyLjk0NTA1NTU2LDQuMDE1MzIyMjIgMy4wOTY5NDQ0NCwzLjMyOTEgMy4zNTYyNzc3OCwyLjY5ODk4ODg5IEMzLjgwOTcyMjIyLDIuODEyNjU1NTYgNC4yNzk4MzMzMywyLjg3ODIxMTExIDQuNzU5NjExMTEsMi44OTM3NjY2NyBMNC43NTk2MTExMSwyLjg5Mzc2NjY3IFogTTQuNzU5NjExMTEsMi40NDcxIEM0LjM0NjE2NjY3LDIuNDMyNzY2NjcgMy45NDA2MTExMSwyLjM3NzY1NTU2IDMuNTQ4MTY2NjcsMi4yODUyMTExMSBDMy44NTQzODg4OSwxLjY4MTMyMjIyIDQuMjYzMzg4ODksMS4xNDE1NDQ0NCA0Ljc1OTYxMTExLDAuNjk2NzY2NjY3IEw0Ljc1OTYxMTExLDIuNDQ3MSBaIE00Ljk5OTk0NDQ0LC0xLjExMTExMTExZS0wNSBDMi4yNDI5NDQ0NCwtMS4xMTExMTExMWUtMDUgLTUuNTU1NTU1NTZlLTA1LDIuMjQyOTg4ODkgLTUuNTU1NTU1NTZlLTA1LDQuOTk5OTg4ODkgQy01LjU1NTU1NTU2ZS0wNSw3Ljc1NzEgMi4yNDI5NDQ0NCw5Ljk5OTk4ODg5IDQuOTk5OTQ0NDQsOS45OTk5ODg4OSBDNy43NTcwNTU1Niw5Ljk5OTk4ODg5IDkuOTk5OTQ0NDQsNy43NTcxIDkuOTk5OTQ0NDQsNC45OTk5ODg4OSBDOS45OTk5NDQ0NCwyLjI0Mjk4ODg5IDcuNzU3MDU1NTYsLTEuMTExMTExMTFlLTA1IDQuOTk5OTQ0NDQsLTEuMTExMTExMTFlLTA1IEw0Ljk5OTk0NDQ0LC0xLjExMTExMTExZS0wNSBaIiBpZD0iRmlsbC0xIiBmaWxsPSIjZmZmZmZmIiBtYXNrPSJ1cmwoI21hc2stMikiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+") center center no-repeat transparent',
                                width: "14px",
                                height: "11px",
                                display: "inline-block",
                                marginRight: "5px",
                              }}
                            />
                            <span
                              style={{
                                boxSizing: "inherit",
                                fontFamily:
                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                              }}
                            >
                              Singapore
                            </span>
                            <span
                              className="dwc-pl--LocaleSelector__LocaleDotSeparator"
                              style={{
                                boxSizing: "inherit",
                                fontFamily:
                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                padding: "0px 7px",
                                fontSize: "18px",
                                position: "relative",
                                top: "-2px",
                              }}
                            >
                              ·
                            </span>
                            <span
                              className="dwc-pl--LocaleSelector__ChevronAlign"
                              style={{
                                boxSizing: "inherit",
                                fontFamily:
                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                              }}
                            >
                              English
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </span>
                  <span
                    style={{
                      boxSizing: "inherit",
                      fontFamily:
                        'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                    }}
                  >
                    <div
                      className="dwc-pl--enbyHeader__NavLogin"
                      style={{
                        boxSizing: "border-box",
                        height: "40px",
                        fontFamily: "sigvar, serif",
                        cssFloat: "right",
                        marginTop: "7px",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <div
                        className="dwc-pl--enbyHeader__SearchWrap"
                        style={{
                          boxSizing: "inherit",
                          display: "inline-block",
                        }}
                      >
                        <div
                          className="dwc-pl--SearchBox__NavSearchBox"
                          style={{
                            display: "inline-block",
                            height: "100%",
                            verticalAlign: "middle",
                            boxSizing: "border-box",
                            marginTop: "5px",
                            marginRight: "9px",
                          }}
                        >
                          <div
                            className="dwc-pl--SearchBox__NavSearchSubmit dwc-pl--SearchBox__IcoSearch"
                            style={{
                              boxSizing: "inherit",
                              width: "36px",
                              height: "43px",
                              color: "transparent",
                              cursor: "pointer",
                              cssFloat: "right",
                              backgroundRepeat: "no-repeat",
                              backgroundImage:
                                'url("../search.svg")',
                            }}
                          />
                          <div
                            className="hydrated"
                            style={{
                              boxSizing: "inherit",
                              visibility: "inherit",
                            }}
                          />
                        </div>
                      </div>
                      <div
                        className="dwc-pl--enbyHeader__NavLoginCell"
                        style={{
                          boxSizing: "inherit",
                          display: "flex",
                          flexDirection: "row",
                          verticalAlign: "top",
                          height: "inherit",
                          position: "relative",
                          top: "1px",
                        }}
                      >
                        <a
                          className="dwc-pl--enbyHeader__NavLink"
                          href="/login"
                          style={{
                            boxSizing: "inherit",
                            transition: "color 0.4s ease 0s",
                            textDecoration: "none",
                            color: "rgb(255, 255, 255)",
                            fontSize: "13px",
                            letterSpacing: "1.2px",
                            fontFamily:
                              'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                            textTransform: "uppercase",
                          }}
                        >
                          Log-in
                        </a>
                        <a
                          className="dwc-pl--enbyHeader__NavLink"
                          href="/signup"
                          target="_top"
                          style={{
                            boxSizing: "inherit",
                            transition: "color 0.4s ease 0s",
                            textDecoration: "none",
                            color: "rgb(255, 255, 255)",
                            fontSize: "13px",
                            letterSpacing: "1.2px",
                            fontFamily:
                              'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                            textTransform: "uppercase",
                          }}
                        >
                          Sign up
                        </a>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <enby-header
          className="hydrated"
          style={{ boxSizing: "inherit", visibility: "inherit" }}
        >
          <div
            className="_hfc"
            style={{
              boxSizing: "inherit",
              fontFamily:
                'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
              fontWeight: 400,
              fontSize: "100%",
              WebkitFontSmoothing: "antialiased",
            }}
          >
            <header
              className="dwc--enbyHeader__HeaderMain"
              style={{
                padding: "0px 10px",
                background:
            "linear-gradient(315deg, rgb(0,0,0) 0%, rgb(7, 7, 14) 20%, rgb(14, 14, 28) 40%, rgb(21, 21, 42) 60%, rgb(28, 28, 56) 80%, rgb(35, 35, 70) 100%",
                border: "none",
                boxSizing: "border-box",
                minHeight: "80px",
                height: "80px",
                width: "100%",
                backgroundColor: "rgb(0, 38, 107)",
                display: "table",
                position: "relative",
              }}
            >
              <h1
                className="dwc--enbyHeader__HeaderTag"
                style={{
                  boxSizing: "inherit",
                  lineHeight: "1em",
                  fontWeight: 700,
                  display: "none",
                }}
              >
                EnbyBase
              </h1>
              <div
                className="dwc--enbyHeader__HeaderNavBar"
                style={{
                  boxSizing: "inherit",
                  margin: "0px auto",
                  padding: "0px",
                  border: "none",
                  display: "table",
                  height: "100%",
                  width: "100%",
                  maxWidth: "1080px",
                  color: "rgb(255, 255, 255)",
                }}
              >
                <div
                  className="dwc--enbyHeader__HeaderLogo"
                  style={{
                    boxSizing: "inherit",
                    border: "none",
                    display: "table-cell",
                    verticalAlign: "middle",
                    width: "150px",
                    paddingRight: "26px",
                  }}
                >
                  <a
                    href="https://enbybase.web.app"
                    style={{
                      boxSizing: "inherit",
                      transition: "color 0.4s ease 0s",
                      textDecoration: "none",
                      color: "rgb(2, 84, 236)",
                    }}
                  >
                    <label
                      className="wcag-visually-hidden"
                      style={{
                        boxSizing: "inherit",
                        border: "0px",
                        padding: "0px",
                        margin: "0px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        height: "1px",
                        width: "1px",
                        clipPath: "inset(50%)",
                        position: "absolute",
                      }}
                    >
                      EnbyBase
                    </label>
                    <img
                            className="rights-logo h-20 w-auto inline-block"
                            alt="EnbyBase"
                            src="../enbybasefooterlogo.png"
                            style={{
                              borderWidth: "0px",
                              borderStyle: "solid",
                              borderColor: "rgb(0,0,0)",
                              boxSizing: "border-box",
                              verticalAlign: "middle",
                              display: "inline-block",
                              height: "auto",
                              maxWidth: "150px",
                              marginTop: '10px'
                        ,left: '10%'
                            }}
                          />
                  </a>
                </div>
                <div
                  className="dwc--enbyHeader__HeaderNavBarBg"
                  style={{ boxSizing: "inherit" }}
                />
                <div
                  className="dwc--enbyHeader__HeaderNavMenu"
                  style={{
                    border: "none",
                    padding: "0px",
                    margin: "0px",
                    display: "table-cell",
                    position: "relative",
                    boxSizing: "border-box",
                    verticalAlign: "middle",
                    zIndex: 8,
                  }}
                >
                  <div
                    className="dwc--enbyHeader__NavMenuWrapper"
                    style={{ boxSizing: "inherit" }}
                  >
                    <div
                      className="dwc--enbyHeader__HeaderMainLinks"
                      style={{
                        display: "table",
                        boxSizing: "border-box",
                        height: "100%",
                        verticalAlign: "top",
                        width: "calc(100% - 150px)",
                        paddingTop: "11px",
                      }}
                      
                    onMouseEnter={() => setShowOverlay(true)}
                    onMouseLeave={() => setShowOverlay(false)}
                    >
                      <div
                        className="dwc--enbyHeader__NavSpace"
                        style={{
                          boxSizing: "inherit",
                          display: "table-cell",
                          verticalAlign: "bottom",
                          height: "calc(46.2px)",
                        }}
                      />
                      <button
                        className="dwc--enbyHeader__NavBtn dwc--enbyHeader__SingleLineLink"
                        
                        target="_self"
                        style={{
                          transition: "color 0.4s ease 0s",
                          textDecoration: "none",
                          display: "inline-block",
                          color: "rgb(255, 255, 255)",
                          boxSizing: "border-box",
                          textAlign: "center",
                          fontSize: "13px",
                          letterSpacing: "1px",
                          textTransform: "uppercase",
                          paddingRight: "18px",
                          lineHeight: 1.2,
                          paddingTop: "30px",
                          paddingBottom: "24px",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        מאמרים
                      </button>
                      <button
                        className="dwc--enbyHeader__NavBtn dwc--enbyHeader__SingleLineLink"
                        
                        target="_self"
                        style={{
                          transition: "color 0.4s ease 0s",
                          textDecoration: "none",
                          display: "inline-block",
                          color: "rgb(255, 255, 255)",
                          boxSizing: "border-box",
                          textAlign: "center",
                          fontSize: "13px",
                          letterSpacing: "1px",
                          textTransform: "uppercase",
                          paddingRight: "18px",
                          lineHeight: 1.2,
                          paddingTop: "30px",
                          paddingBottom: "24px",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        הפורומים
                      </button>
                      <button
                        className="dwc--enbyHeader__NavBtn dwc--enbyHeader__SingleLineLink"
                        
                        target="_self"
                        style={{
                          transition: "color 0.4s ease 0s",
                          textDecoration: "none",
                          display: "inline-block",
                          color: "rgb(255, 255, 255)",
                          boxSizing: "border-box",
                          textAlign: "center",
                          fontSize: "13px",
                          letterSpacing: "1px",
                          textTransform: "uppercase",
                          paddingRight: "18px",
                          lineHeight: 1.2,
                          paddingTop: "30px",
                          paddingBottom: "24px",
                          fontFamily: 'Rubik-Medium'
                        }}
                      >
                       שרת דיסקורד
                      </button>
                      <a
                        className="dwc--enbyHeader__NavBtn dwc--enbyHeader__SingleLineLink"
                        href="/pronounscard"
                        target="_self"
                        style={{
                          transition: "color 0.4s ease 0s",
                          textDecoration: "none",
                          display: "inline-block",
                          color: "rgb(255, 255, 255)",
                          boxSizing: "border-box",
                          textAlign: "center",
                          fontSize: "13px",
                          letterSpacing: "1px",
                          textTransform: "uppercase",
                          paddingRight: "18px",
                          lineHeight: 1.2,
                          paddingTop: "30px",
                          paddingBottom: "24px",
                          fontFamily: 'Rubik-Regular'
                        }}
                      >
                        Pronouns Card
                      </a>
                      <a
                        className="dwc--enbyHeader__NavBtn dwc--enbyHeader__SingleLineLink"
                        href="/miles"
                        target="_self"
                        style={{
                          transition: "color 0.4s ease 0s",
                          textDecoration: "none",
                          display: "inline-block",
                          color: "rgb(255, 255, 255)",
                          boxSizing: "border-box",
                          textAlign: "center",
                          fontSize: "13px",
                          letterSpacing: "1px",
                          textTransform: "uppercase",
                          paddingRight: "18px",
                          lineHeight: 1.2,
                          paddingTop: "30px",
                          paddingBottom: "24px",
                          fontFamily: 'Rubik-Regular'
                        }}
                      >
                        Miles
                      </a>
                      <a
                        className="dwc--enbyHeader__NavBtn dwc--enbyHeader__SingleLineLink"
                        href="/about"
                        target="_self"
                        style={{
                          transition: "color 0.4s ease 0s",
                          textDecoration: "none",
                          display: "inline-block",
                          color: "rgb(255, 255, 255)",
                          boxSizing: "border-box",
                          textAlign: "center",
                          fontSize: "13px",
                          letterSpacing: "1px",
                          textTransform: "uppercase",
                          paddingRight: "18px",
                          lineHeight: 1.2,
                          paddingTop: "30px",
                          paddingBottom: "24px",
                          fontFamily: 'Rubik-Regular'
                        }}
                      >
                        מי אנחנו
                      </a>
                    </div>

                    {showOverlay && (
        <div className="overlaymenubar"
        style={{
          zIndex: 9999,
          position: 'fixed'
        }}
          
        onMouseEnter={() => setShowOverlay(true)}
        onMouseLeave={() => setShowOverlay(false)}>
      <div
        className="DesktopLevelTwo bg-white overflow-hidden"
        tabIndex="-1"
        style={{
          borderWidth: "0px",
          borderStyle: "solid",
          borderColor: "rgb(206, 216, 221)",
          boxSizing: "border-box",
          backgroundColor: "rgba(35, 35, 70,1)",
          overflow: "hidden",
          transition: "opacity 0.3s ease 0s",
          position: "fixed",
          zIndex: 11000,
          left: "0px",
          width: "100%",
          top: "80px",
          minHeight: "350px",
          boxShadow:
            "var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),0 4px 12px #3333331F",
          fontWeight: 600,
          font: "600 16px / 24px mundial",
        }}
      >
        <div
          className="generic-container py-8"
          style={{
            borderWidth: "0px",
            borderStyle: "solid",
            borderColor: "rgb(206, 216, 221)",
            boxSizing: "border-box",
            paddingTop: "2rem",
            paddingBottom: "2rem",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            maxWidth: "1536px",
          }}
        >
          <div
            style={{
              borderWidth: "0px",
              borderStyle: "solid",
              borderColor: "rgb(206, 216, 221)",
              boxSizing: "border-box",
            }}
          >
            <a
              className="AppHyperlink inline-flex items-center flex-wrap text-primary-blue-base hover:text-primary-blue-light text-base font-semibold group"
              href="https://dsc.gg/enbybase"
              rel="noopener noreferrer"
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
                textDecoration: "inherit",
                outlineStyle: "solid",
                outlineColor: "transparent",
                outlineOffset:
                  "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                transitionProperty: "outline-color, outline-offset",
                transitionDuration: "0.2s",
                display: "inline-flex",
                flexWrap: "wrap",
                WebkitBoxAlign: "center",
                alignItems: "center",
                fontWeight: 600,
                fontSize: "1rem",
                lineHeight: "1.5rem",
                color: "rgba(156, 89, 209,1)",
                fontFamily: 'Rubik-Medium'
              }}
            >
              הצטרף לשרת הדיסקורד של EnbyBase{" "}
              <svg
                className="ml-2 rtl:mr-2 fill-current hover:fill-current transition-transform ease-in-out transform rtl:-rotate-180 group-hover:-translate-x-0.5"
                height="1.2em"
                width="1.2em"
                viewBox="0 0 448 512"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  display: "block",
                  verticalAlign: "middle",
                  marginLeft: "0.5rem",
                  fill: "currentcolor",
                  transform:
                    "translate(0) translateY(0) translateZ(0) rotate(180deg) rotateX(0) rotateY(0) rotate(0) skew(0) skewY(0) scaleX(1) scaleY(1) scaleZ(1)",
                  transitionProperty: "transform, -webkit-transform",
                  transitionDuration: "0.15s",
                  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                <path
                  d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                />
              </svg>
            </a>{" "}{" "}{" "}
            <a
              className="AppHyperlink inline-flex items-center flex-wrap text-primary-blue-base hover:text-primary-blue-light text-base font-semibold group"
              href="/miles"
              rel="noopener noreferrer"
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
                textDecoration: "inherit",
                outlineStyle: "solid",
                outlineColor: "transparent",
                outlineOffset:
                  "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                transitionProperty: "outline-color, outline-offset",
                transitionDuration: "0.2s",
                display: "inline-flex",
                flexWrap: "wrap",
                WebkitBoxAlign: "center",
                alignItems: "center",
                fontWeight: 600,
                fontSize: "1rem",
                lineHeight: "1.5rem",
                color: "rgba(156, 89, 209,1)",
                fontFamily: 'Rubik-Medium',
                marginLeft: '20px'
              }}
            >
              הירשם למועדון החדש של EMI Miles{" "}
              <svg
                className="ml-2 rtl:mr-2 fill-current hover:fill-current transition-transform ease-in-out transform rtl:-rotate-180 group-hover:-translate-x-0.5"
                height="1.2em"
                width="1.2em"
                viewBox="0 0 448 512"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  display: "block",
                  verticalAlign: "middle",
                  marginLeft: "0.5rem",
                  fill: "currentcolor",
                  transform:
                    "translate(0) translateY(0) translateZ(0) rotate(180deg) rotateX(0) rotateY(0) rotate(0) skew(0) skewY(0) scaleX(1) scaleY(1) scaleZ(1)",
                  transitionProperty: "transform, -webkit-transform",
                  transitionDuration: "0.15s",
                  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                <path
                  d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                />
              </svg>
            </a>
          </div>
          <div
            className="grid grid-cols-4 gap-x-4 gap-y-8 mt-8 font-light leading-none"
            style={{
              borderWidth: "0px",
              borderStyle: "solid",
              borderColor: "rgb(206, 216, 221)",
              boxSizing: "border-box",
              display: "grid",
              fontWeight: 300,
              lineHeight: 1,
              marginTop: "2rem",
              columnGap: "1rem",
              rowGap: "2rem",
              gridTemplateColumns: "repeat(4, minmax(0px, 1fr))",
            }}
          >
            <nav
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
              }}
            >
              <ul
                className="flex flex-col gap-4"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  listStyle: "none",
                  margin: "0px",
                  padding: "0px",
                  display: "flex",
                  WebkitBoxOrient: "vertical",
                  WebkitBoxDirection: "normal",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <li
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-base text-primary-blue-base hover:text-primary-blue-light font-semibold block"
                    href="/articles"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      fontWeight: 600,
                      fontSize: "1rem",
                      lineHeight: "1.5rem",
                      color: "rgba(156, 89, 209,1)",
                      fontFamily: 'Rubik-Medium'
                    }}
                  >
                    מאמרים
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/news"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",
        fontFamily: 'Rubik-Medium'
                        }}
                      >
                        חדשות
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/identities"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",
        fontFamily: 'Rubik-Medium'
                        }}
                      >
                        זהות מגדרית
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/misc"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        שונות
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </nav>
            <nav
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
              }}
            >
              <ul
                className="flex flex-col gap-4"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  listStyle: "none",
                  margin: "0px",
                  padding: "0px",
                  display: "flex",
                  WebkitBoxOrient: "vertical",
                  WebkitBoxDirection: "normal",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <li
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-base text-primary-blue-base hover:text-primary-blue-light font-semibold block"
                    href="/forums"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      fontWeight: 600,
                      fontSize: "1rem",
                      lineHeight: "1.5rem",
                      color: "rgba(156, 89, 209,1)",
                      fontFamily: 'Rubik-Medium'
                    }}
                  >
                    הפורומים
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/forums/thailand"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        תאילנד
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/forums/singapore"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        סינגפור
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/forums/korea"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        דרום קוריאה
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/forums/israel"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        ישראל
                      </span>
                    </div>
                  </a>
                </li>
                
              </ul>
            </nav>
            <nav
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
              }}
            >
              <ul
                className="flex flex-col gap-4"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  listStyle: "none",
                  margin: "0px",
                  padding: "0px",
                  display: "flex",
                  WebkitBoxOrient: "vertical",
                  WebkitBoxDirection: "normal",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <li
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-base text-primary-blue-base hover:text-primary-blue-light font-semibold block"
                    href="https://dsc.gg/enbybase"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      fontWeight: 600,
                      fontSize: "1rem",
                      lineHeight: "1.5rem",
                      color: "rgba(156, 89, 209,1)",
                      fontFamily: 'Rubik-Medium'
                    }}
                  >
                    שרת דיסקורד
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/discordmods"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        מודרטורים
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/discordbot"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        EnbyBase BOT
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/rules"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        חוקי השרת
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/openparliament"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                פרלמנט פתוח
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/election"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
         בחירות 
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </nav>
            <nav
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
              }}
            >
              <ul
                className="flex flex-col gap-4"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  listStyle: "none",
                  margin: "0px",
                  padding: "0px",
                  display: "flex",
                  WebkitBoxOrient: "vertical",
                  WebkitBoxDirection: "normal",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <li
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-base text-primary-blue-base hover:text-primary-blue-light font-semibold block"
                    href="/about"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      fontWeight: 600,
                      fontSize: "1rem",
                      lineHeight: "1.5rem",
                      color: "rgba(156, 89, 209,1)",
                      fontFamily: 'Rubik-Medium'
                    }}
                  >
                    מי אנחנו
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/projects"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        הפרויקטים שלנו
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="/partnerships"
                    rel="noopener noreferrer"
                    target="_self"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        שותפים
                      </span>
                    </div>
                  </a>
                </li>
                <li
                  className="level3-navigation-list-item"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                >
                  <a
                    className="AppHyperlink inline-flex items-center flex-wrap text-primary-black-base hover:text-primary-black-base"
                    href="https://prestige-flight.web.app/about"
                    rel="noopener noreferrer"
                    target="_blank"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                      textDecoration: "inherit",
                      outlineStyle: "solid",
                      outlineColor: "transparent",
                      outlineOffset:
                        "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                      transitionProperty: "outline-color, outline-offset",
                      transitionDuration: "0.2s",
                      display: "inline-flex",
                      flexWrap: "wrap",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      color: "rgba(236,236,236,1)",
                    }}
                  >
                    <div
                      className="level3-navigation-item"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        lineHeight: "20px",
                      }}
                    >
                      <span
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",fontFamily: 'Rubik-Medium'
                        }}
                      >
                        על PrestigeFlight
                      </span>
                    </div>
                    <svg
                      className="fill-current inline-block ml-3 rtl:mr-3 text-base"
                      height="1.2em"
                      width="1.2em"
                      viewBox="0 0 448 512"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        verticalAlign: "middle",
                        display: "inline-block",
                        fontSize: "1rem",
                        lineHeight: "1.5rem",
                        marginLeft: "0.75rem",
                        fill: "currentcolor",
                      }}
                    >
                      <path
                        d="M280 80C266.7 80 256 69.25 256 56C256 42.75 266.7 32 280 32H424C437.3 32 448 42.75 448 56V200C448 213.3 437.3 224 424 224C410.7 224 400 213.3 400 200V113.9L200.1 312.1C191.6 322.3 176.4 322.3 167 312.1C157.7 303.6 157.7 288.4 167 279L366.1 80H280zM0 120C0 89.07 25.07 64 56 64H168C181.3 64 192 74.75 192 88C192 101.3 181.3 112 168 112H56C51.58 112 48 115.6 48 120V424C48 428.4 51.58 432 56 432H360C364.4 432 368 428.4 368 424V312C368 298.7 378.7 288 392 288C405.3 288 416 298.7 416 312V424C416 454.9 390.9 480 360 480H56C25.07 480 0 454.9 0 424V120z"
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",
                        }}
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      </div>)}

                    <div
                      className="dwc--enbyHeader__HeaderNavLocale"
                      style={{
                        border: "none",
                        position: "absolute",
                        display: "block",
                        color: "rgb(255, 255, 255)",
                        boxSizing: "border-box",
                        top: "0px",
                        right: "0px",
                        bottom: "50px",
                        direction: 'ltr'
                      }}
                    >
                      <span
                        style={{
                          fontFamily:
                            'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                          boxSizing: "inherit",
                        }}
                      />
                      <span
                        style={{
                          fontFamily:
                            'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                          boxSizing: "inherit",
                        }}
                      >
                        <locale-selector
                          className="hydrated"
                          style={{
                            visibility: "inherit",
                            boxSizing: "inherit",
                          }}
                        >
                          <div style={{ boxSizing: "inherit" }}>
                            <div
                              className="dwc--LocaleSelector__Root22"
                              style={{
                                transition: "all 0.4s ease 0s",
                                textDecoration: "none",
                                fontFamily:
                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "1.5px",
                                fontWeight: 500,
                                color: "rgb(255, 255, 255)",
                                display: "inline-block",
                                textAlign: "right",
                                boxSizing: "border-box",
                                cursor: "pointer",
                                marginTop: "2px",
                                cssFloat: 'left'
                              }}
                            >
                              <span
                                className="dwc--LocaleSelector__HideNonDesktop"
                                style={{
                                  fontFamily:
                                    'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                  boxSizing: "inherit",
                                }}
                              >
                                <span
                                  className="dwc--enbyHeader__HeaderFeedback"
                                  style={{
                                    fontFamily:
                                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                  }}
                                >
                                  <a
                                    className="dwc--enbyHeader__FeedbackHelp dwc--newsAlert__container"
                                    style={{
                                      boxSizing: "inherit",
                                      transition: "color 0.4s ease 0s",
                                      textDecoration: "none",
                                      display: "inline-block",
                                      position: "relative",
                                      paddingLeft: "15px",
                                      paddingBottom: "2px",
                                      paddingRight: "17px",
                                      color: "rgb(255, 255, 255)",
                                    }}
                                  >
                                    <span
                                      id="newsAlert_bell_white"
                                      className="dwc--newsAlert__bell__white"
                                      style={{
                                        fontFamily:
                                          'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                        boxSizing: "inherit",
                                        background:
                                          'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI5MDRfMTEwMTIpIj4KPHBhdGggZD0iTTcuNzEwNzMgMTAuMjkyQzguMTc5MjcgMTAuMjkyIDguNDI2ODEgMTAuODQ2NyA4LjExNDI3IDExLjE5NTVDNy45MTEyNCAxMS40MjI3IDcuNjYyNDggMTEuNjA0NCA3LjM4NDMgMTEuNzI4OEM3LjEwNjEyIDExLjg1MzEgNi44MDQ4MSAxMS45MTcyIDYuNTAwMSAxMS45MTdDNi4xOTU0IDExLjkxNzIgNS44OTQwOSAxMS44NTMxIDUuNjE1OTEgMTEuNzI4OEM1LjMzNzczIDExLjYwNDQgNS4wODg5NyAxMS40MjI3IDQuODg1OTQgMTEuMTk1NUM0LjU4Njk0IDEwLjg2MTggNC44MDAzNSAxMC4zNDAyIDUuMjI5MzUgMTAuMjk1OEw1LjI4ODk0IDEwLjI5MjVMNy43MTA3MyAxMC4yOTJaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNi41MDAwNSAxLjA4MzAxQzcuMjM1NjQgMS4wODMwMSA3Ljg1NzQ3IDEuNTcyMTMgOC4wNTczNSAyLjI0MjcyTDguMDgyMjYgMi4zMzUzNEw4LjA4NjU5IDIuMzU4NjNDOC42ODM3MiAyLjY5NTUgOS4xOTI1NiAzLjE2OTAyIDkuNTcxNDIgMy43NDA0MkM5Ljk1MDI4IDQuMzExODMgMTAuMTg4NCA0Ljk2NDg1IDEwLjI2NjMgNS42NDYwMUwxMC4yODE0IDUuODAxNDdMMTAuMjkxNyA1Ljk1ODAxVjcuNTQ1NjNMMTAuMzAzMSA3LjYxOTNDMTAuMzc3MyA4LjAxODQxIDEwLjU5ODEgOC4zNzUzMSAxMC45MjIyIDguNjE5NzZMMTEuMDEyNyA4LjY4MzEzTDExLjEwMDQgOC43MzY3NkMxMS41NjYzIDkuMDAwNTUgMTEuNDAzOCA5LjY5MzM0IDEwLjg5NjIgOS43NDY0MkwxMC44MzM0IDkuNzQ5NjdIMi4xNjY3MkMxLjYwOTg5IDkuNzQ5NjcgMS40MTU0MyA5LjAxMDg0IDEuODk5NjggOC43MzY3NkMyLjEwNjA3IDguNjE5OTYgMi4yODQzOSA4LjQ1OTQgMi40MjIxNCA4LjI2NjM2QzIuNTU5ODggOC4wNzMzMSAyLjY1MzcgNy44NTI0NiAyLjY5NzAxIDcuNjE5M0wyLjcwODM5IDcuNTQxODRMMi43MDg5MyA1LjkzMzA5QzIuNzQxOTUgNS4yMjU2MSAyLjk0Nzg5IDQuNTM3MDEgMy4zMDg3MSAzLjkyNzU1QzMuNjY5NTMgMy4zMTgxIDQuMTc0MjMgMi44MDYzOCA0Ljc3ODY0IDIuNDM3MTdMNC45MTI5NyAyLjM1ODA5TDQuOTE4MzkgMi4zMzQ4QzQuOTk1MDEgMi4wMTA5IDUuMTY5MTUgMS43MTgyOSA1LjQxNzMxIDEuNDk2NDhDNS42NjU0NyAxLjI3NDY3IDUuOTc1NyAxLjEzNDMyIDYuMzA2MTQgMS4wOTQzOEw2LjQwNDcyIDEuMDg1MTdMNi41MDAwNSAxLjA4MzAxWiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yOTA0XzExMDEyIj4KPHJlY3Qgd2lkdGg9IjEzIiBoZWlnaHQ9IjEzIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=") center center no-repeat transparent',
                                        width: "13px",
                                        height: "13px",
                                        display: "inline-block",
                                        position: "relative",
                                        top: "3px",
                                        left: "-1px",
                                      }}
                                    />
                                    <span
                                      id="newsAlert_bell_yellow"
                                      className="dwc--newsAlert__bell__yellow"
                                      style={{
                                        fontFamily:
                                          'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                        boxSizing: "inherit",
                                        background:
                                          'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI5MTBfMTEzMTYpIj4KPHBhdGggZD0iTTcuNzEwNzMgMTAuMjkyQzguMTc5MjcgMTAuMjkyIDguNDI2ODEgMTAuODQ2NyA4LjExNDI3IDExLjE5NTVDNy45MTEyNCAxMS40MjI3IDcuNjYyNDggMTEuNjA0NCA3LjM4NDMgMTEuNzI4OEM3LjEwNjEyIDExLjg1MzEgNi44MDQ4MSAxMS45MTcyIDYuNTAwMSAxMS45MTdDNi4xOTU0IDExLjkxNzIgNS44OTQwOSAxMS44NTMxIDUuNjE1OTEgMTEuNzI4OEM1LjMzNzczIDExLjYwNDQgNS4wODg5NyAxMS40MjI3IDQuODg1OTQgMTEuMTk1NUM0LjU4Njk0IDEwLjg2MTggNC44MDAzNSAxMC4zNDAyIDUuMjI5MzUgMTAuMjk1OEw1LjI4ODk0IDEwLjI5MjVMNy43MTA3MyAxMC4yOTJaIiBmaWxsPSIjRkY5RjAwIi8+CjxwYXRoIGQ9Ik02LjUwMDA1IDEuMDgzMDFDNy4yMzU2NCAxLjA4MzAxIDcuODU3NDcgMS41NzIxMyA4LjA1NzM1IDIuMjQyNzJMOC4wODIyNiAyLjMzNTM0TDguMDg2NTkgMi4zNTg2M0M4LjY4MzcyIDIuNjk1NSA5LjE5MjU2IDMuMTY5MDIgOS41NzE0MiAzLjc0MDQyQzkuOTUwMjggNC4zMTE4MyAxMC4xODg0IDQuOTY0ODUgMTAuMjY2MyA1LjY0NjAxTDEwLjI4MTQgNS44MDE0N0wxMC4yOTE3IDUuOTU4MDFWNy41NDU2M0wxMC4zMDMxIDcuNjE5M0MxMC4zNzczIDguMDE4NDEgMTAuNTk4MSA4LjM3NTMxIDEwLjkyMjIgOC42MTk3NkwxMS4wMTI3IDguNjgzMTNMMTEuMTAwNCA4LjczNjc2QzExLjU2NjMgOS4wMDA1NSAxMS40MDM4IDkuNjkzMzQgMTAuODk2MiA5Ljc0NjQyTDEwLjgzMzQgOS43NDk2N0gyLjE2NjcyQzEuNjA5ODkgOS43NDk2NyAxLjQxNTQzIDkuMDEwODQgMS44OTk2OCA4LjczNjc2QzIuMTA2MDcgOC42MTk5NiAyLjI4NDM5IDguNDU5NCAyLjQyMjE0IDguMjY2MzZDMi41NTk4OCA4LjA3MzMxIDIuNjUzNyA3Ljg1MjQ2IDIuNjk3MDEgNy42MTkzTDIuNzA4MzkgNy41NDE4NEwyLjcwODkzIDUuOTMzMDlDMi43NDE5NSA1LjIyNTYxIDIuOTQ3ODkgNC41MzcwMSAzLjMwODcxIDMuOTI3NTVDMy42Njk1MyAzLjMxODEgNC4xNzQyMyAyLjgwNjM4IDQuNzc4NjQgMi40MzcxN0w0LjkxMjk3IDIuMzU4MDlMNC45MTgzOSAyLjMzNDhDNC45OTUwMSAyLjAxMDkgNS4xNjkxNSAxLjcxODI5IDUuNDE3MzEgMS40OTY0OEM1LjY2NTQ3IDEuMjc0NjcgNS45NzU3IDEuMTM0MzIgNi4zMDYxNCAxLjA5NDM4TDYuNDA0NzIgMS4wODUxN0w2LjUwMDA1IDEuMDgzMDFaIiBmaWxsPSIjRkY5RjAwIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjkxMF8xMTMxNiI+CjxyZWN0IHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K") center center no-repeat transparent',
                                        width: "13px",
                                        height: "13px",
                                        position: "relative",
                                        top: "3px",
                                        left: "-1px",
                                        display: "none",
                                      }}
                                    />
                                    <div
                                      className="dwc--newsList__container"
                                      style={{
                                        boxSizing: "inherit",
                                        padding: "20px",
                                        borderRadius: "2px",
                                        border: "1px solid rgb(204, 204, 204)",
                                        transition: "all 0.5s ease 0s",
                                        width: "380px",
                                        color: "rgb(102, 102, 102)",
                                        textAlign: "left",
                                        position: "absolute",
                                        left: "-166px",
                                        top: "25px",
                                        backgroundColor: "rgb(255, 255, 255)",
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.1) 0px 5px 30px",
                                        display: "none",
                                      }}
                                    >
                                      <i
                                        className="dwc--newsList__container__arrowUp"
                                        style={{
                                          boxSizing: "inherit",
                                          borderStyle: "solid",
                                          borderColor: "rgb(255, 255, 255)",
                                          borderImage: "initial",
                                          borderWidth: "0px 3px 3px 0px",
                                          padding: "3px",
                                          backgroundColor: "rgb(255, 255, 255)",
                                          display: "inline-block",
                                          transform: "rotate(-135deg)",
                                          position: "absolute",
                                          top: "-5px",
                                          left: "48%",
                                        }}
                                      />
                                      <div
                                        className="dwc--newsList__heading"
                                        style={{
                                          boxSizing: "inherit",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          className="dwc--newsList__heading__important"
                                          style={{
                                            boxSizing: "inherit",
                                            gap: "8px",
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                          }}
                                        >
                                          <img
                                            className="dwc--newsList__important__img"
                                            alt="important notes"
                                            src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn1%2Fico-alert--orange.svg?alt=media&token=f6402b03-e144-4a92-b5eb-615e89000416"
                                            style={{
                                              boxSizing: "inherit",
                                              border: "0px",
                                              maxWidth: "initial",
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontFamily:
                                                'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                              boxSizing: "inherit",
                                              color: "rgb(0, 38, 107)",
                                              letterSpacing: "2px",
                                              fontWeight: 600,
                                              fontSize: "12px",
                                              position: "relative",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            Important
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="dwc--newsList__wrapper"
                                        style={{
                                          boxSizing: "inherit",
                                          textTransform: "initial",
                                          fontSize: "14px",
                                          fontWeight: 400,
                                          lineHeight: "20px",
                                          letterSpacing: "0px",
                                        }}
                                      >
                                        <ul
                                          style={{
                                            boxSizing: "inherit",
                                            fontSize: "1em",
                                            lineHeight: "1.5em",
                                            padding: "0px",
                                            margin: "15px 0px",
                                            listStyleType: "none",
                                          }}
                                        >
                                          <li
                                            className="dwc--newsList__item"
                                            style={{
                                              boxSizing: "inherit",
                                              margin: "0px 0px 15px",
                                              gap: "5px",
                                              marginTop: "0px",
                                              display: "flex",
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontFamily:
                                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                                boxSizing: "inherit",
                                              }}
                                            >
                                              1.
                                            </span>
                                            <a
                                              href=""
                                              style={{
                                                boxSizing: "inherit",
                                                transition:
                                                  "color 0.4s ease 0s",
                                                textDecoration: "none",
                                                color: "rgb(102, 102, 102)",
                                              }}
                                            >
                                              Advisory on phishing scams and
                                              good cybersecurity practices{" "}
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div style={{ boxSizing: "inherit" }}>
                                        <a
                                          className="dwc--newsAlert__viewall"
                                          href=""
                                          style={{
                                            boxSizing: "inherit",
                                            transition: "color 0.4s ease 0s",
                                            textDecoration: "none",
                                            color: "rgb(2, 84, 236)",
                                            textTransform: "initial",
                                            fontSize: "14px",
                                            letterSpacing: "0px",
                                          }}
                                        >
                                          View all
                                          <img
                                            alt="View all"
                                            src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn1%2Fchevron-blue.svg?alt=media&token=aa69a86f-63d8-4fe7-b9d6-d375f62f0524"
                                            style={{
                                              boxSizing: "inherit",
                                              border: "0px",
                                              maxWidth: "initial",
                                              margin: "0px 0px 0px 6px",
                                              width: "8px",
                                              height: "8px",
                                            }}
                                          />
                                        </a>
                                      </div>
                                    </div>
                                  </a>
                                  <span
                                    className="dwc--enbyHeader__OrangeSeparator"
                                    style={{
                                      fontFamily:
                                        'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                      boxSizing: "inherit",
                                      borderLeft: "1px solid rgb(255, 159, 0)",
                                      paddingRight: "10px",
                                      display: "inline-block",
                                      height: "8px",
                                    }}
                                  />
                                  <span title="Theme (light/dark)"
                              style={{
                                boxSizing: "inherit",
                                transition: "color 0.4s ease 0s",
                                textDecoration: "none",
                                paddingRight: "17px",
                                color: "rgb(255, 255, 255)"}}>
                                THEME
                              </span>
                                  <span
                                    className="dwc--enbyHeader__OrangeSeparator"
                                    style={{
                                      fontFamily:
                                        'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                      boxSizing: "inherit",
                                      borderLeft: "1px solid rgb(255, 159, 0)",
                                      paddingRight: "10px",
                                      display: "inline-block",
                                      height: "8px",
                                    }}
                                  />
                                  <a
                                    className="dwc--enbyHeader__FeedbackHelp"
                                    href="/feedback"
                                    style={{
                                      boxSizing: "inherit",
                                      transition: "color 0.4s ease 0s",
                                      textDecoration: "none",
                                      paddingRight: "17px",
                                      color: "rgb(255, 255, 255)",
                                    }}
                                  >
                                    Feedback
                                  </a>
                                </span>
                              </span>
                              <span
                                className="dwc--LocaleSelector__LangSelector"
                                style={{
                                  fontFamily:
                                    'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                  boxSizing: "inherit",
                                }}
                              >
                                <div
                                  className="dwc--LocaleSelector__GlobeIcon"
                                  style={{
                                    boxSizing: "inherit",
                                    width: "14px",
                                    height: "11px",
                                    display: "inline-block",
                                    marginRight: "5px",
                                    position: "relative",
                                    top: "2px",
                                  }}
                                />
                                <span
                                  style={{
                                    fontFamily:
                                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                  }}
                                ><a href="/" style={{textDecoration: 'none', color: '#FFFFFF', textDecorationLine:'none'}}>
                                  English
                                </a></span>
                                <span
                                  className="dwc--LocaleSelector__LocaleDotSeparator"
                                  style={{
                                    fontFamily:
                                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                    padding: "0px 7px",
                                    fontSize: "18px",
                                    position: "relative",
                                    top: "1px",
                                  }}
                                >
                                  ·
                                </span>
                                <span
                                  className="dwc--LocaleSelector__ChevronAlign"
                                  style={{
                                    fontFamily:
                                      'LINESeedSansTH_Rg, "FoundryContextW03Regular", "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                  }}
                                >
                                  ภาษาไทย
                                </span>
                                <span
                                  className="dwc--LocaleSelector__LocaleDotSeparator"
                                  style={{
                                    fontFamily:
                                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                    padding: "0px 7px",
                                    fontSize: "18px",
                                    position: "relative",
                                    top: "1px",
                                  }}
                                >
                                  ·
                                </span>
                                <span
                                  className="dwc--LocaleSelector__ChevronAlign"
                                  style={{
                                    fontFamily:
                                      'MYingHeiPRCW48W3, "FoundryContextW03Regular", "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                  }}
                                >
                                  简体中文
                                </span>
                                <span
                                  className="dwc--LocaleSelector__LocaleDotSeparator"
                                  style={{
                                    fontFamily:
                                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                    padding: "0px 7px",
                                    fontSize: "18px",
                                    position: "relative",
                                    top: "1px",
                                  }}
                                >
                                  ·
                                </span>
                                <span
                                  className="dwc--LocaleSelector__ChevronAlign"
                                  style={{
                                    fontFamily:
                                      'NotoSansKR-Regular, "FoundryContextW03Regular", "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                  }}
                                >
                                  한국어
                                </span>
                                <span
                                  className="dwc--LocaleSelector__LocaleDotSeparator"
                                  style={{
                                    fontFamily:
                                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                    padding: "0px 7px",
                                    fontSize: "18px",
                                    position: "relative",
                                    top: "1px",
                                  }}
                                >
                                  ·
                                </span>
                                <span
                                  className="dwc--LocaleSelector__ChevronAlign"
                                  style={{
                                    fontFamily:
                                      'Rubik-Regular, "FoundryContextW03Regular", "Open Sans", Arial, Helvetica, sans-serif',
                                    boxSizing: "inherit",
                                  }}
                                >
                                  עברית
                                </span>
                              </span>
                              
{/*language here*/}{/*}
<ul
        id="navList_LangMenu"
        className="nav-list lang-list"
        style={{
          boxSizing: "border-box",
          listStyle: "none",
          margin: "0px",
          color: "rgb(40, 92, 126)",
          flexDirection: "column",
          marginTop: "0px",
          marginBottom: "0px",
          position: "absolute",
          right: '330px',
          textAlign: "start",
          inset: "64px auto auto",
          overflow: "initial",
          padding: "1rem 0px",
          backgroundColor: "rgb(255, 255, 255)",
          boxShadow: "rgba(32, 32, 32, 0.36) 0px 10px 7px",
          overflowY: "initial",
          paddingLeft: "0px",
          width: "auto",
          zIndex: 2,
          minWidth: "150px",
          display: "flex",
          cursor: "pointer",
          fontFamily: "Rubik, sans-serif",
          font: "16px / 24px Rubik, sans-serif",
        }}
      >
        <li
          id="LangMenu1"
          className="active"
          style={{
            boxSizing: "border-box",
            padding: "0px",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            cursor: "pointer",
          }}
        >
          <a
            id="LangMenu_1"
            href="https://www.gov.il/he"
            target="_self"
            style={{
              boxSizing: "border-box",
              textDecoration: "none",
              display: "inline-block",
              width: "100%",
              margin: "0px",
              padding: "0.5rem 1rem",
              color: "rgb(0, 104, 245)",
              outline: "0px",
            }}
          >
            <span style={{ boxSizing: "border-box" }}>עברית</span>
          </a>
        </li>
        <li
          id="LangMenu2"
          style={{
            boxSizing: "border-box",
            padding: "0px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <a
            id="LangMenu_2"
            href="https://www.gov.il/en"
            target="_self"
            style={{
              boxSizing: "border-box",
              textDecoration: "none",
              display: "inline-block",
              width: "100%",
              margin: "0px",
              padding: "0.5rem 1rem",
              color: "rgb(12, 48, 88)",
            }}
          >
            <span style={{ boxSizing: "border-box" }}>English</span>
          </a>
        </li>
        <li
          id="LangMenu3"
          style={{
            boxSizing: "border-box",
            padding: "0px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <a
            id="LangMenu_3"
            href="https://www.gov.il/ar"
            target="_self"
            style={{
              boxSizing: "border-box",
              textDecoration: "none",
              display: "inline-block",
              width: "100%",
              margin: "0px",
              padding: "0.5rem 1rem",
              color: "rgb(12, 48, 88)",
            }}
          >
            <span style={{ boxSizing: "border-box" }}>العربية</span>
          </a>
        </li>
        <li
          id="LangMenu4"
          style={{
            boxSizing: "border-box",
            padding: "0px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <a
            id="LangMenu_4"
            href="https://www.gov.il/ru"
            target="_self"
            style={{
              boxSizing: "border-box",
              textDecoration: "none",
              display: "inline-block",
              width: "100%",
              margin: "0px",
              padding: "0.5rem 1rem",
              color: "rgb(12, 48, 88)",
            }}
          >
            <span style={{ boxSizing: "border-box" }}>Русский</span>
          </a>
        </li>
        <li
          id="LangMenu5"
          style={{
            boxSizing: "border-box",
            padding: "0px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <a
            id="LangMenu_5"
            href="https://www.gov.il/es"
            target="_self"
            style={{
              boxSizing: "border-box",
              textDecoration: "none",
              display: "inline-block",
              width: "100%",
              margin: "0px",
              padding: "0.5rem 1rem",
              color: "rgb(12, 48, 88)",
            }}
          >
            <span style={{ boxSizing: "border-box" }}>Español</span>
          </a>
        </li>
        <li
          id="LangMenu6"
          style={{
            boxSizing: "border-box",
            padding: "0px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <a
            id="LangMenu_6"
            href="https://www.gov.il/fr"
            target="_self"
            style={{
              boxSizing: "border-box",
              textDecoration: "none",
              display: "inline-block",
              width: "100%",
              margin: "0px",
              padding: "0.5rem 1rem",
              color: "rgb(12, 48, 88)",
            }}
          >
            <span style={{ boxSizing: "border-box" }}>Français</span>
          </a>
        </li>
      </ul>*/}


                            </div>
                          </div>
                        </locale-selector>
                      </span>
                      <span
                        style={{
                          fontFamily:
                            'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                          boxSizing: "inherit",
                        }}
                      >
                        <div
                          className="dwc--enbyHeader__NavLogin22"
                          style={{
                            boxSizing: "border-box",
                            height: "40px",
                            fontFamily: "sigvar, serif",
                            cssFloat: "left",
                            marginTop: "10px",
                            float: 'left',
                            position: 'relative'
                          }}
                        >
                          <span
                            style={{
                              fontFamily:
                                'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                              boxSizing: "inherit",
                            }}
                          >
                            <search-box
                              className="hydrated"
                              style={{
                                visibility: "inherit",
                                boxSizing: "inherit",
                              }}
                            >
                              <context-consumer
                                className="hydrated"
                                style={{
                                  visibility: "inherit",
                                  boxSizing: "inherit",
                                }}
                              >
                                <div
                                  className="dwc--SearchBox__NavSearchBox"
                                  style={{
                                    display: "inline-block",
                                    height: "100%",
                                    verticalAlign: "middle",
                                    boxSizing: "border-box",
                                    marginTop: "5px",
                                    marginRight: "9px",
                                  }}
                                >
                                  <div
                                    className="dwc--SearchBox__NavSearchSubmit dwc--SearchBox__IcoSearch"
                                    style={{
                                      boxSizing: "inherit",
                                      backgroundRepeat: "no-repeat",
                                      width: "36px",
                                      height: "43px",
                                      color: "transparent",
                                      cursor: "pointer",
                                      cssFloat: "right",
                                      backgroundImage:
                                        'url("https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn1%2Fsearchsq.svg?alt=media&token=765e105e-845d-4219-8feb-4a0e6f0bfb42")',
                                    }}
                                  />
                                  <tool-tip
                                    className="hydrated"
                                    style={{
                                      visibility: "inherit",
                                      boxSizing: "inherit",
                                    }}
                                  />
                                </div>
                              </context-consumer>
                            </search-box>
                          </span>
                          <div
                            className="dwc--enbyHeader__NavLoginCell"
                            style={{
                              boxSizing: "inherit",
                              display: "inline-block",
                              verticalAlign: "top",
                              height: "inherit",
                            }}
                          >
                            <a href="/account"
                              className="dwc--enbyHeader__NavLink"
                              style={{
                                boxSizing: "inherit",
                                transition: "color 0.4s ease 0s",
                                textDecoration: "none",
                                color: "rgb(255, 255, 255)",
                                fontSize: "13px",
                                letterSpacing: "1.2px",
                                fontFamily:
                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                textTransform: "uppercase",
                              }}
                            >
                              Log-in /
                              </a>
                            <a href="/account"
                              className="dwc--enbyHeader__NavLink"
                              target="_top"
                              style={{
                                boxSizing: "inherit",
                                transition: "color 0.4s ease 0s",
                                textDecoration: "none",
                                color: "rgb(255, 255, 255)",
                                fontSize: "13px",
                                letterSpacing: "1.2px",
                                fontFamily:
                                  'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                                textTransform: "uppercase",
                              }}
                            >
                              {" "}Sign Up
                            </a>
                          </div>
                        </div>
                      </span>
                      <div style={{ boxSizing: "inherit" }}>
                        <div style={{ boxSizing: "inherit" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div
              className="dwc--enbyHeader__SubNav__Root false dwc--enbyHeader__SubNav__DesktopZ"
              style={{
                transition: "none 0s ease 0s",
                position: "absolute",
                display: "block",
                boxSizing: "border-box",
                width: "100%",
                height: "calc(100% - 77px)",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                opacity: 0,
                pointerEvents: "none",
                top: "77px",
                overflowY: "visible",
                zIndex: 8,
              }}
            >
              <div
                className="dwc--enbyHeader__SubNav__Content"
                style={{
                  padding: "0px 10px 30px",
                  display: "block",
                  boxSizing: "border-box",
                  width: "100%",
                  height: "auto",
                  backgroundColor: "rgb(255, 255, 255)",
                }}
              >
                <div
                  className="dwc--enbyHeader__SubNav__Div"
                  style={{
                    boxSizing: "inherit",
                    gap: "1.8rem 0.6rem",
                    margin: "0px auto",
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
                    width: "100%",
                    maxWidth: "1080px",
                    paddingTop: "20px",
                    fontFamily:
                      'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
                    letterSpacing: "0.02em",
                  }}
                />
              </div>
            </div>
            <light-box
              className="hydrated"
              style={{ visibility: "inherit", boxSizing: "inherit" }}
            />
            <light-box
              className="hydrated"
              style={{ visibility: "inherit", boxSizing: "inherit" }}
            />
            <splash-loader
              className="hydrated"
              style={{ visibility: "inherit", boxSizing: "inherit" }}
            />
            <google-captcha
              className="hydrated"
              style={{ visibility: "inherit", boxSizing: "inherit" }}
            />
          </div>
          <div
            className="_hfc"
            style={{
              boxSizing: "inherit",
              fontFamily:
                'FoundryContextW03Regular, "Open Sans", Arial, Helvetica, sans-serif',
              fontWeight: 400,
              fontSize: "100%",
              WebkitFontSmoothing: "antialiased",
            }}
          >
            <enby-cookie
              className="hydrated"
              style={{ visibility: "inherit", boxSizing: "inherit" }}
            >
              <div style={{ boxSizing: "inherit" }}>
                <light-box
                  className="hydrated"
                  style={{ visibility: "inherit", boxSizing: "inherit" }}
                />
              </div>
            </enby-cookie>
          </div>
        </enby-header>
      </div></body>
    </>
  );
}


export default Header2HE;
